export const domainTag = 'frontend_webOrder_';

export const featureFlags = [
  'avoidDataDog',
  'crossSell',
  'customisedWebApps',
  'enableCustomTip',
  'internationalisedAddress',
  'loyaltyStatus',
  'orderStatus',
  'payGreen',
  'phoneSmsHCaptcha',
  'reorder',
  'reorderMenu',
  'reorderOrderHistoryDetails',
  'showRoundUp',
  'useDOMAKey',
] as const;

export type FeatureFlag = (typeof featureFlags)[number];
